import { render, staticRenderFns } from "./SendRequestRepliesTab.vue?vue&type=template&id=5bf00c2e&scoped=true&lang=pug"
import script from "./SendRequestRepliesTab.vue?vue&type=script&lang=ts"
export * from "./SendRequestRepliesTab.vue?vue&type=script&lang=ts"
import style0 from "./SendRequestRepliesTab.vue?vue&type=style&index=0&id=5bf00c2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf00c2e",
  null
  
)

export default component.exports